import umComment from './packages/comment/index.js';
import umImg from './packages/img/index.js';
import umAnimate from './packages/animate/index.js';
import umList from './packages/list/index.js';
import umAttachment from './packages/attachment/index.js';
import umSelectuser from './packages/selectuser/index.js';
import umDialog from './packages/dialog/index.js';
import umAddlist from './packages/addlist/index.js';
import umCandidate from './packages/candidate/index.js';
import umSimg from './packages/simg/index.js';
import umMselector from './packages/mselector/index.js';
import umZan from './packages/zan/index.js';
import umReadcount from './packages/readcount/index.js';
import umMcomment from './packages/mcomment/index.js';
import umCollect from './packages/collect/index.js';
import umShare from './packages/share/index.js';
import umDownloadApp from "./packages/downloadAppTip/index.js"
import umRecharge from "./packages/recharge/index.js"
import umRange from "./packages/range/index.js"
import umIdentity from "./packages/identity/index.js"
import umMrange from "./packages/mrange/index.js"
import umMidentity from "./packages/midentity/index.js"
import umEdituser from "./packages/edituser/index.js"

const components = [
    umComment,
    umImg,
    umAnimate,
    umList,
    umAttachment,
    umSelectuser,
    umDialog,
    umAddlist,
    umCandidate,
    umSimg,
    umMselector,
    umZan,
    umReadcount,
    umMcomment,
    umCollect,
    umShare,
    umDownloadApp,
    umRecharge,
    umRange,
    umIdentity,
    umMrange,
    umMidentity,
    umEdituser
]

const install = function(Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component);
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  umComment,
  umImg,
  umAnimate,
  umList,
  umAttachment,
  umSelectuser,
  umDialog,
  umAddlist,
  umCandidate,
  umSimg,
  umMselector,
  umZan,
  umReadcount,
  umMcomment,
  umCollect,
  umShare,
  umDownloadApp,
  umRecharge,
  umRange,
  umIdentity,
  umMrange,
  umMidentity,
  umEdituser
}


// WEBPACK FOOTER //
// ./src/index.js